export default __webpack_public_path__ + "static/media/verified.0bd434dd.svg";